export default "__VITE_ASSET__B8a50IJQ__"